import React from 'react'

export default function PageLoading({ showSpinner = false }) {
  const className = showSpinner ? 'spinner' : 'wrap wrap--high wrap--loading'

  return <div className={className}></div>
}
